import React from "react";
import { FormGroup, Toggle } from "@velaro/velaro-component-lib";
import { SiteSettings } from "../types";
import { Site } from "@/types";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import consentGraphic from "@/assets/images/Chat-Data-Compliance_1.png";

interface ManageDataPrivacySettingsProps {
  site: Site;
  setSite: React.Dispatch<React.SetStateAction<Site>>;
  siteSettings: SiteSettings;
  setSiteSettings: (updater: React.SetStateAction<SiteSettings>) => void;
  isVisible: (text: string) => boolean;
}

export default function ManageDataPrivacySettings({
  site,
  setSite,
  siteSettings,
  setSiteSettings,
  isVisible
}: ManageDataPrivacySettingsProps) {
  return (
    <div className="w-full">
      {isVisible("opt out data disclosure privacy") && (
        <div className="w-full relative">
          <div>
            <div className="form-group flex mb-6 items-start gap-8">
              <div className="flex flex-col gap-1" style={{ width: "35%" }}>
                <div className="font-normal">Chat Communication Consent</div>
                <div className="text-base text-slate-600 font-normal">
                  Display a message to request user consent for collecting and
                  storing chat-related data in compliance with privacy policies.
                </div>
              </div>
              <span style={{ width: "15%" }}>
                <Toggle
                  toggled={siteSettings.dataDisclosureOptOut}
                  changeToggle={() => {
                    const newToggleValue = !siteSettings.dataDisclosureOptOut;

                    setSiteSettings(() => ({
                      ...siteSettings,
                      dataDisclosureOptOut: newToggleValue
                    }));

                    // If enabling toggle and no text exists, set default text
                    if (newToggleValue && !site.dataDisclosureText) {
                      const defaultText = '<p>By starting this chat, you agree to share your information with us. This conversation may be recorded and used for service, support, and quality assurance purposes. To learn more, please review our <a href="https://velaro.com/privacy-policy"><span style="color: rgb(0, 0, 255);">Privacy Policy</span></a>.</p>';
                      setSite((prev) => ({
                        ...prev,
                        dataDisclosureText: defaultText
                      }));
                    }
                  }}
                />
              </span>
            </div>
            <div className="absolute top-0" style={{ left: "55%" }}>
              <img src={consentGraphic} alt="Consent" className="w-96 h-auto" />
            </div>
            {siteSettings.dataDisclosureOptOut && (
              <div style={{ width: "40%" }} className="mt-2">
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    licenseKey: "GPL",
                    toolbar: ["bold", "italic", "link"],
                    link: {
                      addTargetToExternalLinks: true,
                      defaultProtocol: "https://"
                    }
                  }}
                  data={
                    site.dataDisclosureText ||
                    '<p>By starting this chat, you agree to share your information with us. This conversation may be recorded and used for service, support, and quality assurance purposes. To learn more, please review our <a href="https://velaro.com/privacy-policy"><span style="color: rgb(0, 0, 255);">Privacy Policy</span></a>.</p>'
                  }
                  onChange={(event: any, editor: { getData: () => string }) => {
                    const data = editor.getData();
                    setSite((prev) => ({ ...prev, dataDisclosureText: data }));
                  }}
                />
                <style>{`
                  .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
                    border-color: #d1d5db;
                  }
                  .ck.ck-balloon-panel {
                    z-index: 10000 !important;
                  }
                  .ck-powered-by {
                    display: none !important;
                  }
                  .ck-editor__top .ck-sticky-panel .ck-toolbar,
                  .ck-editor__top .ck-sticky-panel__content,
                  .ck.ck-toolbar {
                    border-top-left-radius: 12px !important;
                    border-top-right-radius: 12px !important;
                  }
                  .ck.ck-editor__main > .ck-editor__editable {
                    border-bottom-left-radius: 12px !important;
                    border-bottom-right-radius: 12px !important;
                  }
                  .ck-content {
                    font-size: 14px !important;
                    line-height: 1.5 !important;
                  }
                `}</style>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
